import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=46f0e1f8"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f0e1f8')) {
      api.createRecord('46f0e1f8', component.options)
    } else {
      api.reload('46f0e1f8', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=46f0e1f8", function () {
      api.rerender('46f0e1f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/menu/components/DataForm.vue"
export default component.exports